<template>
    <div class="container">
        <div class="header">
            <vendor-bar></vendor-bar>
        </div>

        <div class="main">
            <div class="left-stance"></div>
            <el-main class="container">
                <transition name="move" mode="out-in">
                    <router-view></router-view>
                </transition>
            </el-main>
            <div class="right-stance"></div>
        </div>

        <div class="footer">
            <footer-bar></footer-bar>
        </div>
    </div>
</template>
<script>

    // import HeaderBar from '../../ma/comm/MaHanderBar'
    import FooterBar from '../../Footer'
    import VendorBar from "@/view/index/service/VendorBar";

    // noinspection JSUnusedGlobalSymbols
    export default {
        name: 'VendorMain',
        components: {VendorBar, FooterBar} // FooterBar,
    }
</script>

<style scoped>
    .main {
        padding: 10px 30px 20px 30px;
        margin-top: 4rem;
        min-height: 30rem;
        margin-bottom: 7%;
        overflow: auto;
    }

    @media screen and (min-width: 1700px) {
        .left-stance {
            width: 10rem
        }

        .right-stance {
            width: 18rem
        }
    }

    @media screen  and (max-width: 900px) {
        .container {
            min-width: 900px;
        }
    }

    /*.aside {*/
    /*height: 900px;*/
    /*width: 120px;*/
    /*background: palegreen;*/
    /*}*/

    .header {
        height: 20px;
    }

</style>
